/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  var $window = $(window),
      $windowHeight = $window.height(),
      $windowWidth = $window.width(),
      $isTablet = ($windowWidth <= 1024) ? true : false,
      $isMobile = ($windowWidth <= 640) ? true : false,
      $scrollTop = $window.scrollTop();
      $headerTop = 0;

  function checkNotificationBar() {
    if($('.notification-bar').length>0) {
      $headerTop = $('.notification-bar').outerHeight();
      $('html').get(0).style.setProperty('--notification-height', $headerTop+'px');
    }
  }
  checkNotificationBar();

  function windowResize() {
    $windowHeight = $window.height();
    $windowWidth = $window.width();
    $isTablet = ($windowWidth <= 1024) ? true : false;
    $isMobile = ($windowWidth <= 640) ? true : false;
    
    checkNotificationBar();
  }

  function windowScroll() {
    $scrollTop = $window.scrollTop();

    if($scrollTop > $headerTop) {
      $('.header').addClass('fixed');
    } else {
      $('.header').removeClass('fixed');
    }
  }

  /* enable/disable scrolling */
  function preventDefault(e) {
    e = e || window.event;
    if(e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;  
  }
  function disableScroll() {
    if(window.addEventListener) {
      window.addEventListener('DOMMouseScroll', preventDefault, false);
    }
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove  = preventDefault; // mobile
  }
  function enableScroll() {
    if(window.removeEventListener) {
      window.removeEventListener('DOMMouseScroll', preventDefault, false);
    }
    window.onmousewheel = document.onmousewheel = null; 
    window.onwheel = null; 
    window.ontouchmove = null;    
  }

  /* mailchimp subscribe */
  function sendNewsletterForm($form) {
    $('.newsletter-form input[type="submit"]').attr('disabled', true);

    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: "application/json; charset=utf-8",
      error: function(err) {
      },
      success: function(data) {
        if(data.result !== "success") {
          $('#newsletter-message').html(data.msg.replace('0 - ', '')).addClass('error');
        } else {
          $('#newsletter-message').html(data.msg).removeClass('error');
        }
        $('.newsletter-form input[type="submit"]').attr('disabled', false);
      }
    });
  }

  var $newsletterForm = $('.newsletter-form');
  if($newsletterForm.length > 0) {
    $newsletterForm.bind('submit', function(e) {
      if(e) {
        e.preventDefault();
      }

      sendNewsletterForm($(this));
    });
  }

  function checkServicePartnerFilter($province) {
    if($('body').hasClass('service-partners') && $('.msp-filter').length>0) {
      var $url_params = new URLSearchParams(window.location.search);
      
      if(!$url_params.has('province')) {
        if($('body').hasClass('fr')) {
          $province = $province + '-fr';
        }
        $('.msp-filter select[name="province"]').val($province);
        $('.msp-filter form').trigger('submit');
      }
    }
  }

  /* update product select options based on current province */
  function updateProducts(province) {
    if(province_products[province]) {
      jQuery('#product-select option[value!=""]').attr('disabled', true);

      for(var $i=0; $i<province_products[province].length; $i++) {
        jQuery('#product-select option[value="'+province_products[province][$i]+'"]').attr('disabled', false);
      }

      if(jQuery('#product-select option:selected').prop('disabled') === true) {
        var product_select = document.getElementById('product-select');
        product_select.value = '';
        productSelectChanged(product_select);
      }
    }
  }

  /* change icon in product select */
  function productSelectChanged() {
    var product = this.value;

    if(product === 'paint' || product === 'paint-cans') {
      $('#product-select').css({backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_paint)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'paint-aerosol') {
      $('#product-select').css({backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_paint_aerosol)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'ontario-lights') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_lights)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'lights') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_lights)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'commercial-lights') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_commercial_lights)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'hhw') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_hhw)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'hsp') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_hhw)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'non-refillable-pressurized-cylinders') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_non_refillable_pressurized_cylinders)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'refillable-propane-cylinders') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_refillable_propane_cylinders)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'alarms') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_alarms)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'paintshare') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_paintshare)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'residential-fixtures') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_residential_fixtures)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'commercial-fixtures') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_commercial_fixtures)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else if(product === 'ballasts') {
      $('#product-select').css({ backgroundImage:"url('data:image/svg+xml;base64,"+window.btoa(unescape(encodeURIComponent(icon_ballasts)))+"'), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    } else {
      $('#product-select').css({ backgroundImage:"url(''), url('/wp-content/themes/product-care-recycling/dist/images/icon-arrow-down.svg')" });
    }
  }

  /* get province from google geocode results */
  function getProvinceFromResults(results) {
    for(var i = 0; i < results.address_components.length; i++) {
      if(results.address_components[i].types[0] === 'administrative_area_level_1') {
        return results.address_components[i].short_name.toLowerCase();
      }
    }
    return 'bc';
  }

  /* product image effects */
  function productImage() {
    $('.product-image img').imagesLoaded(function() {
      $('.product-image img').addClass('loaded');
    });
  }

  /* product video */
  function videoOverlay() {
    $('a.video').click(function(e) {
      e.preventDefault();

      $('.video-overlay iframe').attr('src', $(this).attr('href'));
      $('.video-overlay').fadeIn();
    });
    $('.video-overlay .close').click(function(e) {
      e.preventDefault();

      $('.video-overlay').fadeOut(function() {
        $('.video-overlay iframe').attr('src', '');
      });
    });
  }


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $window.resize(windowResize);
        windowScroll();
        $window.scroll(windowScroll);

        // set initial location
        if(navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
            var latlng = position.coords.latitude + "," + position.coords.longitude;
            var apiurl = 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCfR1q47DgBizD6o9y37QAS9oIZ0R0QYXM&latlng=' + latlng;

            jQuery.getJSON(apiurl, function(data) {
              if(data.status == 'OK') {
                if(data.results[0]) {
                  for(var i = 0; i < data.results[0].address_components.length; i++) {
                    if(data.results[0].address_components[i].types[0] === 'administrative_area_level_1') {
                      $('html').addClass('region:'+data.results[0].address_components[i].short_name.toLowerCase());

                      if($('body').hasClass('page-template-template-home')) {
                        updateProducts(data.results[0].address_components[i].short_name.toLowerCase());
                      }
                    }
                  };
                }
              }
            });
            //LOCATOR.setProvince();
          }, function() {
            // fallback to ip lookup
            if($('body').hasClass('page-template-template-home')) {
              jQuery.ajax('https://api.ipdata.co/?api-key=1955cfc26f85e2101dc961e35a949ef1d7fa541be59d2719597b7d39').then(
                function success(response) {
                  $('html').addClass('region:'+response.region_code.toLowerCase());

                  updateProducts(response.region_code.toLowerCase());
                }
              );
            }
          });
        } else {
          // fallback to ip lookup
          if($('body').hasClass('page-template-template-home')) {
            jQuery.ajax('https://api.ipdata.co/?api-key=1955cfc26f85e2101dc961e35a949ef1d7fa541be59d2719597b7d39').then(
              function success(response) {
                $('html').addClass('region:'+response.region_code.toLowerCase());

                updateProducts(response.region_code.toLowerCase());
              }
            );
          }
        }

        /* navigation */
        $(document).click(function(e) {
          if(!$(e.target).closest('.nav-primary .nav > li.menu-item-has-children').length) {
            $('.nav-primary .nav > li.menu-item-has-children.open').removeClass('open');
          }
        });
        $('.nav-primary .nav > li.menu-item-has-children').hoverIntent({
          over: function() {
            $('.nav-primary .nav > li.menu-item-has-children.open').removeClass('open');
            $(this).addClass('open');
          },
          out: function() {
            $(this).removeClass('open');
          },
          timeout: 100
        });
        $('.nav-primary .nav > li.menu-item-has-children > a').click(function(e) {
          e.preventDefault();

          /*$('.nav-primary .nav > li.menu-item-has-children.open').removeClass('open');
          $(this).parent().addClass('open');*/
        });

        /* search overlay */
        $('.search-toggle').click(function(e) {
          e.preventDefault();

          $('.search-overlay').fadeIn(function() {
            $('.search-overlay input').focus();
          });
        });
        $('.search-overlay .close').click(function(e) {
          e.preventDefault();

          $('.search-overlay').fadeOut();
        });

        /* mobile navigation */
        $('.menu-toggle').click(function(e) {
          e.preventDefault();

          $('.mobile-menu').fadeIn();
        });
        $('.mobile-menu .close').click(function(e) {
          e.preventDefault();

          $('.mobile-menu').fadeOut();
        });
        $('.nav-mobile li.menu-item-has-children > a').click(function(e) {
          e.preventDefault();

          var $parent = $(this).parent();
          if($parent.hasClass('open')) {
            $parent.removeClass('open');
          } else {
            $parent.addClass('open');
          }
        });
        $('.nav-mobile a.menu-back').click(function(e) {
          e.preventDefault();

          var $parent = $(this).parent().parent();
          $parent.removeClass('open');
        });

        /* background image loading */
        $('.bg img').imagesLoaded(function() {
          $('.bg img').addClass('loaded');
        });

        /* faqs */
        $('.faq-question').click(function(e) {
          e.preventDefault();

          var $faqItem = $(this).parent();
          if($faqItem.hasClass('open')) {
            $faqItem.removeClass('open');
            $(this).next().slideUp();
          } else {
            $faqItem.addClass('open');
            $(this).next().slideDown();
          }
        });

        /* accordions */
        $('.accordion-title').click(function(e) {
          e.preventDefault();

          var $accordionItem = $(this).parent();
          $accordionItem.toggleClass('open');
        });
        /*$('.accordion-show').click(function(e) {
          e.preventDefault();

          var $accordionItem = $(this).parent().parent();
          $accordionItem.addClass('open');
        });
        $('.accordion-hide').click(function(e) {
          e.preventDefault();

          var $accordionItem = $(this).parent().parent();
          $accordionItem.removeClass('open');
        });*/

        /* member updates */
       /* if(typeof(Storage) !== 'undefined' && localStorage.hide_member_updates) {
          $('.msp-updates').remove();
        } else {
          $('.msp-updates').show();
        }
        $('.updates-close').click(function(e) {
          e.preventDefault();
          $('.msp-updates').remove();

          if(typeof(Storage) !== 'undefined') {
            localStorage.hide_member_updates = true;
          }
        });*/

        /* geolocation */
        /*var $province = 'bc';
        if(typeof(Storage) !== 'undefined' && localStorage.province) {
          var $province = localStorage.province.toLowerCase();
          checkServicePartnerFilter($province);
        }
        if(navigator.geolocation && !$province) {
          navigator.geolocation.getCurrentPosition(function(position) {
            var latlng = position.coords.latitude + "," + position.coords.longitude;
            var apiurl = 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCfR1q47DgBizD6o9y37QAS9oIZ0R0QYXM&latlng=' + latlng;

            $.getJSON(apiurl, function(data) {
              if(data.status == 'OK') {
                if(data.results[1]) {
                  for(var i = 0; i < data.results.length; i++) {
                    if(data.results[i].types[0] === 'locality') {
                      var $province = data.results[i].address_components[2].short_name.toLowerCase();
                      localStorage.province = $province;
                      checkServicePartnerFilter($province);
                    }
                  }
                }
              }
            });
          }, function() {
            // fallback to ip lookup
            $.ajax('https://api.ipdata.co/?api-key=1955cfc26f85e2101dc961e35a949ef1d7fa541be59d2719597b7d39').then(
              function success(response) {
                var $province = response.region_code.toLowerCase();
                localStorage.province = $province;
                checkServicePartnerFilter($province);
              }
            );
          });
        } else if(!$province) {
          // fallback to ip lookup
          $.ajax('https://api.ipdata.co/?api-key=1955cfc26f85e2101dc961e35a949ef1d7fa541be59d2719597b7d39').then(
            function success(response) {
              var $province = response.region_code.toLowerCase();
              localStorage.province = $province;
              checkServicePartnerFilter($province);
            }
          );
        } else {
          checkServicePartnerFilter($province);
        }*/

        /* msp filter */
        $(document).click(function(e) {
          if(!$(e.target).closest('.msp-util__province, .msp-util__product, .msp-util__sorting').length) {
            $('.filter-options.open, .sort-options.open').removeClass('open');
          }
        });
        $('.msp-util button').click(function(e) {
          e.preventDefault();

          var $options = $(this).next();
          
          if($options.hasClass('open')) {
            $options.removeClass('open');
          } else {
            $('.filter-options.open, .sort-options.open').removeClass('open');
            $options.addClass('open');
          }
        });

        function checkAccordions() {
          $('.accordion').removeClass('show-accordion');
          $('.accordion').each(function() {
            var $accordion = $(this);

            if($accordion.find('.show-province.show-product').length) {
              $accordion.addClass('show-accordion');
            }
          });

          if($('.show-accordion').length) {
            $('.accordion.open').removeClass('open');
            $('.show-accordion').first().addClass('open');
            $('.no-results').hide();
          } else {
            $('.no-results').show();
          }
        }

        function filterByProvince($province, $provinceName) {
          if($province) {
            $('.filter-options a[data-province].selected').removeClass('selected');
            $('.filter-options a[data-province="'+$province+'"]').addClass('selected');

            $('.province-toggle').removeClass('active');
            $('.province-selected .text').attr('data-province', $province);
            $('.province-selected .text').attr('data-province-name', $provinceName);
            $('.province-selected').addClass('active');
            $('.msp-util__province .filter-options').removeClass('open');

            $('.card').each(function() {
              var $card = $(this);

              var $provinces = [];
              if($card.data('province')) {
                $provinces = $card.data('province').split(',');
              }

              if($provinces.includes($province)) {
                $card.parent().addClass('show-province');
              } else {
                $card.parent().removeClass('show-province');
              }
            });
          } else {
            $('.filter-options a[data-province].selected').removeClass('selected');
            $('.province-toggle').addClass('active');
            $('.province-selected').removeClass('active');
            $('.card').each(function() {
              var $card = $(this);
              $card.parent().addClass('show-province');
            });
          }

          checkAccordions();
        }

        function filterByProduct($product, $productName) {
          if($product) {
            $('.filter-options a[data-product].selected').removeClass('selected');
            $('.filter-options a[data-product="'+$product+'"]').addClass('selected');

            $('.product-toggle').removeClass('active');
            $('.product-selected .text').html($productName);
            $('.product-selected').attr('class', 'product-selected');
            $('.product-selected').addClass('colour-'+$product).addClass('active');
            $('.msp-util__product .filter-options').removeClass('open');

            $('.card').each(function() {
              var $card = $(this);

              var $products = [];
              if($card.data('product')) {
                $products = $card.data('product').split(',');
              }

              if($products.includes($product)) {
                $card.parent().addClass('show-product');
              } else {
                $card.parent().removeClass('show-product');
              }
            });
          } else {
            $('.filter-options a[data-product].selected').removeClass('selected');
            $('.product-toggle').addClass('active');
            $('.product-selected').removeClass('active');
            $('.card').each(function() {
              var $card = $(this);
              $card.parent().addClass('show-product');
            });
          }

          checkAccordions();
        }

        $('.filter-options a[data-province]').click(function(e) {
          var $filter = $(this);
          var $is_util = ($filter.closest('.msp-util').length > 0);

          if($('body').hasClass('page-template-template-msp-news') && $is_util) {
            return true;
          }

          e.preventDefault();

          var $selectedProvince = $filter.data('province');
          var $selectedProvinceName = $filter.data('province-name');

          filterByProvince($selectedProvince, $selectedProvinceName);
        });
        $('.msp-util .province-selected a').click(function(e) {
          if($('body').hasClass('page-template-template-msp-news')) {
            return true;
          }
          
          e.preventDefault();

          filterByProvince(false, false);
        })

        $('.filter-options a[data-product]').click(function(e) {
          var $filter = $(this);
          var $is_util = ($filter.closest('.msp-util').length > 0);

          if($('body').hasClass('page-template-template-msp-news') && $is_util) {
            return true;
          }

          e.preventDefault();

          var $selectedProduct = $filter.data('product');
          var $selectedProductName = $filter.data('product-name');

          filterByProduct($selectedProduct, $selectedProductName);
        });
        $('.msp-util .product-selected a').click(function(e) {
          if($('body').hasClass('page-template-template-msp-news')) {
            return true;
          }
          
          e.preventDefault();

          filterByProduct(false, false);
        });

        function sortBy($sort) {
          $('.sort-options a[data-sort]').removeClass('selected');
          $('.sort-options a[data-sort="'+$sort+'"]').addClass('selected');
          $('.msp-util__sorting .sort-options').removeClass('open');

          var $orderby = 'province-order';
          var $order = 'ASC';
          if($sort === 'name-asc') {
            $orderby = 'name';
            $order = 'ASC';
          } else if($sort === 'updated') {
            $orderby = 'updated';
            $order = 'DESC';
          }

          $('.msp-resources ul.grid').each(function() {
            var $resourcesGrid = $(this);
            var $resources = $resourcesGrid.find('li:not(.list-view__heading)');

            $resources.sort(function(a, b) {
              var $valueA = $(a).find('.card').data($orderby);
              var $valueB = $(b).find('.card').data($orderby);

              if($order === 'ASC') {
                if($orderby === 'product' && ($valueA === 'General' || $valueB === 'General')) {
                  if($valueA === 'General') {
                    return -1;
                  } else if($valueB === 'General') {
                    return 1;
                  } else {
                    return 0
                  }
                } else {
                  return ($valueA < $valueB) ? -1 : ($valueA > $valueB) ? 1 : 0;
                }
              } else {
                if($orderby === 'product' && ($valueA === 'General' || $valueB === 'General')) {
                  if($valueA === 'General') {
                    return 1;
                  } else if($valueB === 'General') {
                    return -1;
                  } else {
                    return 0
                  }
                } else {
                  return ($valueA > $valueB) ? -1 : ($valueA < $valueB) ? 1 : 0;
                }
              }
            });

            $resourcesGrid.find('li:not(.list-view__heading)').remove();
            $resourcesGrid.append($resources);
          });
        }
        sortBy('province');

        $('.sort-options a[data-sort]').click(function(e) {
          e.preventDefault();

          sortBy($(this).data('sort'));
        });

        $('.filter-menu-toggle').click(function(e) {
          e.preventDefault();

          $('html').addClass('state--msp-util-overlay-open');
        });

        $('.msp-util-reset').click(function(e) {
          if($('body').hasClass('page-template-template-msp-news')) {
            var $url = location.protocol + "//" + location.host + location.pathname;

            window.location = $url;

            return true;
          }

          e.preventDefault();

          filterByProvince(false, false);
          filterByProduct(false, false);

          $('html').removeClass('state--msp-util-overlay-open');
        });

        $('.msp-util-apply').click(function(e) {
          if($('body').hasClass('page-template-template-msp-news')) {
            var $province = ($('.msp-util-overlay a[data-province].selected')) ? $('.msp-util-overlay a[data-province].selected').data('province') : '';
            var $product = ($('.msp-util-overlay a[data-product].selected')) ? $('.msp-util-overlay a[data-product].selected').data('product') : '';
            var $url = location.protocol + "//" + location.host + location.pathname + '?province='+$province+'&product='+$product;

            window.location = $url;

            return true;
          }

          e.preventDefault();

          $('html').removeClass('state--msp-util-overlay-open');
        });

        $('.msp-util-overlay__mask').click(function(e) {
          if($('body').hasClass('page-template-template-msp-news')) {
            return true;
          }

          e.preventDefault();

          $('html').removeClass('state--msp-util-overlay-open');
        });


        /* msp mobile nav */
        $('.msp-sidebar').click(function(e) {
          $(this).toggleClass('open');
        });

        /* program mobile nav */
        $('.program-tabs h5').click(function(e) {
          $(this).next().toggleClass('open');
        });
      },
      finalize: function() {
      }
    },
    'page_template_template_home': {
      init: function() {
        // set initial location
        /*if(navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
            var latlng = position.coords.latitude + "," + position.coords.longitude;
            var apiurl = 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCfR1q47DgBizD6o9y37QAS9oIZ0R0QYXM&latlng=' + latlng;

            jQuery.getJSON(apiurl, function(data) {
              if(data.status == 'OK') {
                if(data.results[0]) {
                  for(var i = 0; i < data.results[0].address_components.length; i++) {
                    if(data.results[0].address_components[i].types[0] === 'administrative_area_level_1') {
                      updateProducts(data.results[0].address_components[i].short_name.toLowerCase());
                    }
                  };
                }
              }
            });
            //LOCATOR.setProvince();
          }, function() {
            // fallback to ip lookup
            jQuery.ajax('https://api.ipdata.co/?api-key=1955cfc26f85e2101dc961e35a949ef1d7fa541be59d2719597b7d39').then(
              function success(response) {
                updateProducts(response.region_code.toLowerCase());
              }
            );
          });
        } else {
          // fallback to ip lookup
          jQuery.ajax('https://api.ipdata.co/?api-key=1955cfc26f85e2101dc961e35a949ef1d7fa541be59d2719597b7d39').then(
            function success(response) {
              updateProducts(response.region_code.toLowerCase());
            }
          );
        }*/

        /* location autocomplete */
        var location_search_input = document.getElementById('location-search');
        var location_search = new google.maps.places.Autocomplete(location_search_input, {
          types: ['geocode'],
          componentRestrictions: {'country': ['ca']}
        });
        google.maps.event.addDomListener(location_search_input, 'keydown', function(e) { 
          if(e.keyCode === 13) {
            e.preventDefault();
          }
        });
        location_search.addListener('place_changed', function() {
          var place = this.getPlace(),
              province = getProvinceFromResults(place);

          updateProducts(province);
        });

        /* product select */
        var product_select = document.getElementById('product-select');
        product_select.addEventListener('change', productSelectChanged);

        $('.collection-sites-filter form').submit(function(e) {
          e.preventDefault();

          window.location = $(this).attr('action')+'#'+$(this).serialize();
        });
      },
      finalize: function() {
      }
    },
    'page_template_template_product_paint': {
      init: function() {
        productImage();
        videoOverlay();
        
        if($('.swiper-slide').length>1) {
          var mySwiper = new Swiper('.swiper-container', {
            loop:true,
            effect:'fade',
            fadeEffect: {
              crossFade:true
            },
            pagination: {
              el:'.swiper-pagination',
              type:'custom',
              clickable:true
            },
          });

          $('.swiper-pagination-bullet').click(function() {
            $('.swiper-pagination-bullet-active').removeClass('swiper-pagination-bullet-active');
            $(this).addClass('swiper-pagination-bullet-active');
          });
        }
      }
    },
    'page_template_template_product_lights': {
      init: function() {
        productImage();
        videoOverlay();
      }
    },
    'page_template_template_product_hhw': {
      init: function() {
        productImage();
        videoOverlay();
      }
    },
    'page_template_template_product_alarms': {
      init: function() {
        productImage();
        videoOverlay();
      }
    },
    'page_template_template_product_paintshare': {
      init: function() {
        productImage();
        videoOverlay();

        if($('.swiper-slide').length>1) {
          var mySwiper = new Swiper('.swiper-container', {
            loop:true,
            effect:'fade',
            fadeEffect: {
              crossFade:true
            },
            pagination: {
              el:'.swiper-pagination',
              clickable:true
            },
            navigation: {
              nextEl:'.swiper-button-next',
              prevEl:'.swiper-button-prev',
            },
          });
        }
      }
    },
    'page_template_template_component_landing': {
      init: function() {
        // hero: product
        if($('.page-header .product-image').length > 0) {
          productImage();
        }

        // component: video
        videoOverlay();

        // component: accordion
        $('.accordion__heading').click(function(e) {
          e.preventDefault();

          var $accordionItem = $(this).closest('.accordion__item');
          var $accordionCopy = $accordionItem.find('.accordion__copy');
          var $accordionCopyHeight = $accordionItem.find('.accordion__copy-wrapper').outerHeight();

          if($accordionItem.hasClass('open')) {
            $accordionCopy.css({ height:0 });
            $accordionItem.removeClass('open');
          } else {
            //$('.accordion__item.open').removeClass('open').find('.accordion__copy').css({ height:0 });
            $accordionCopy.css({ height:$accordionCopyHeight });
            $accordionItem.addClass('open');
          }
        });

        // component: faqs
        $('.faq__question').click(function(e) {
          e.preventDefault();

          var $faqItem = $(this).closest('.faq__item');
          var $faqAnswer = $faqItem.find('.faq__answer');
          var $faqAnswerHeight = $faqItem.find('.faq__answer-wrapper').outerHeight();

          if($faqItem.hasClass('open')) {
            $faqAnswer.css({ height:0 });
            $faqItem.removeClass('open');
          } else {
            //$('.accordion__item.open').removeClass('open').find('.accordion__copy').css({ height:0 });
            $faqAnswer.css({ height:$faqAnswerHeight });
            $faqItem.addClass('open');
          }
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
